<template>
  <v-menu
    v-model="mostrar"
    :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        v-bind="attrs"
        v-on="on">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
      v-if="mixValidaScopesActions(2)"
      link>
        <v-list-item-icon>
          <v-icon>mdi-pencil</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Editar</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
      v-if="mixValidaScopesActions(3)"
      link>
        <v-list-item-icon>
          <v-icon>mdi-delete</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Borrar</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- <v-divider></v-divider>
      <v-list-item
        v-for="(opcion, index) in opciones"
        :key="index"
        :to="{ name: opcion.ruta }">
        <v-list-item-content>
          <v-list-item-title>{{ opcion.nombre }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'OpcionesContratos',
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      mostrar: false,
      opciones: [
        {
          nombre: 'Anticipos',
          ruta: 'ejecucion',
          icono: '',
        },
        {
          nombre: 'Fianzas',
          ruta: 'ejecucion',
          icono: '',
        },
        {
          nombre: 'Convenios',
          ruta: 'ejecucion',
          icono: '',
        },
        {
          nombre: 'Catálogo',
          ruta: 'ejecucion',
          icono: '',
        },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
